// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__6pfWC g-focus-border-and-box-shadow-light"};